import gql from 'graphql-tag';

export const ttsQuery = gql`
  query tts($speakingRate: SPEAKING_RATE = MEDIUM, $text: String!) {
    tts(speakingRate: $speakingRate, text: $text) {
      source
    }
  }
`;
